"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = require("./base");

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _decorators = require("decorators");

var _class, _descriptor, _descriptor2, _descriptor3, _temp;

var SectionContainer = (_class = (_temp =
/*#__PURE__*/
function (_BlockContainer) {
  babelHelpers.inherits(SectionContainer, _BlockContainer);

  function SectionContainer() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, SectionContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(SectionContainer)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "linkUrl", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "title", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "summary", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(SectionContainer, [{
    key: "getChildren",
    value: function getChildren() {
      return _react.default.createElement("div", {
        className: _classList.default.join('inner-content', this.linkUrl && 'with-link')
      }, _react.default.createElement("h1", {
        className: "title"
      }, this.title), _react.default.createElement("div", {
        className: "summary"
      }, this.summary), this.linkUrl && _react.default.createElement("a", {
        className: "link",
        href: this.linkUrl
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "arrow_forward"
      })), _react.default.createElement("div", {
        className: "inner-content-stack"
      }, babelHelpers.get(babelHelpers.getPrototypeOf(SectionContainer.prototype), "getChildren", this).call(this)));
    }
  }]);
  return SectionContainer;
}(_base.BlockContainer), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "linkUrl", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "summary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = SectionContainer;